import { render, staticRenderFns } from "./SkanskaPPM.vue?vue&type=template&id=1af355b1&"
import script from "./SkanskaPPM.vue?vue&type=script&lang=ts&"
export * from "./SkanskaPPM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports